export const persistToken = (token: string): void => {
  localStorage.setItem('accessToken', token)
}

export const persistUser = (userId: string): void => {
  localStorage.setItem('user', userId)
}

export const readToken = (): string => {
  return localStorage.getItem('accessToken') || ''
}

export const readUser = (): string => localStorage.getItem('user') || ''
export const deleteToken = (): void => localStorage.removeItem('accessToken')
export const deleteUser = (): void => localStorage.removeItem('user')
